import { ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ValidatorService } from '../../validator/validator.service';

@Component({
  selector: 'app-mu-form-textarea',
  templateUrl: './mu-form-textarea.component.html',
  styleUrls: ['./mu-form-textarea.component.sass'],
})
export class MuFormTextareaComponent implements OnInit {
  @Input() formData: UntypedFormGroup;
  @Input() controlName: string;
  @Input() rows = 1;
  @Input() maxLength = 100;
  @Input() editableMask: boolean;
  @HostBinding('class') baseClass = 'mu-form-textarea ';

  constructor(public changeDetectorRef: ChangeDetectorRef, public validatorService: ValidatorService) {
    /** */
  }

  ngOnInit(): void {
    /** */
  }
}
